// extracted by mini-css-extract-plugin
module.exports = {"gridCol":"72px","gridGutter":"24px","gridColCount":"12","gridWidth":"90%","gridWidthK":".9","gridMinK":".75","gridMaxK":"1","minSideMargin":"16px","scrollBarWidth":"20px"};